import { integrationService, gameService } from '@/services'
import { createMutationMixin } from '@/shared'
import { removeTypename, useQuery } from 'codefabrik-gui-vue/src/apollo'
import { SET_GAME_ID } from '@/store/game'

export const useCreateGame = (methodName) => createMutationMixin({
  name: methodName,
  service: [gameService.createGame, 'games.saveSuccess'],
  onSuccess: navigateToManagePage
})

export function useGame (name) {
  return {
    mixins: [
      useQuery({
        name: name,
        serviceFn: gameService.getGame,
        variables () {
          return { input: { id: this.$route.params.id }}
        },
        mappingFunctions: {
          [name]: [(game) => removeTypename(game), () => {
          }]
        }
      })
    ]
  }
}

export function useVersion (name) {
  return {
    mixins: [
      useQuery({
        name: name,
        serviceFn: gameService.getVersion,
        variables () {
          return { input: { id: this.$route.params.id } }
        },
        mappingFunctions: {
          [name]: [(version) => removeTypename(version), () => {
          }]
        }
      })
    ]
  }
}

export function useGames (name) {
  return {
    mixins: [
      useQuery({
        name: name,
        serviceFn: gameService.getGames,
        mappingFunctions: {
          [name]: [(gamePage) => gamePage.game, () => []]
        }
      })
    ]
  }
}

export function useIntegrationsByGame (name, gameId) {
  return {
    mixins: [
      useQuery({
        name: name,
        serviceFn: integrationService.getIntegrationGames,
        skipIf () {
          return this[gameId] === null
        },
        variables () {
          return {
            input: {
              gameId: this[gameId]
            },
          }
        },
        mappingFunctions: {
          [name]: [(integrationGames) => integrationGames.map(it => {
            return {
              name: it.integration.name,
              version: it.gameVersion.version
            }
          }), () => []]
        }
      })
    ]
  }
}

export function useGameVersions (name, gameId) {
  return {
    mixins: [
      useQuery({
        name: name,
        skipIf () {
          return this[gameId] === '' || this[gameId] === null
        },
        variables () {
          return { input: { limit: 0, offset: 0, gameId: this[gameId] } }
        },
        serviceFn: gameService.getGameVersions,
        mappingFunctions: {
          [name]: [(gameVersionPage) => gameVersionPage.gameVersion, () => []]
        }
      })
    ]
  }
}

export const useEditGame = (methodName) => createMutationMixin({
  name: methodName,
  service: [gameService.editGame, 'games.saveSuccess'],
  mapInput (input) {
    return { id: this.$route.params.id, ...input }
  },
  onSuccess: navigateToManagePage
})

export const useEditVersion = (methodName) => createMutationMixin({
  name: methodName,
  service: [gameService.editVersion, 'games.saveSuccess'],
  mapInput (input) {
    const { gameId, ...noGameId } = input
    return { id: this.$route.params.id, ...noGameId }
  },
  onSuccess (response, input) {
    this.$router.push({ name: 'game-versions' })
  }
})

export const useCreateVersion = (methodName) => createMutationMixin({
  name: methodName,
  service: [gameService.createVersion, 'versions.saveSuccess'],
  onSuccess (response, input) {
    this.$store.commit('game/' + SET_GAME_ID, input.gameId)
    this.$router.push({ name: 'game-versions'})
  }
})

export const useDeleteVersion = (methodName) => createMutationMixin({
  name: methodName,
  service: [gameService.deleteVersion, 'versions.deleteSuccess'],
  onSuccess (response, input) {
    this.$router.push({ name: 'game-versions' })
  }
})

export const useDeleteGame = (methodName) => createMutationMixin({
  name: methodName,
  service: [gameService.deleteGame, 'games.deleteSuccess'],
  mapInput () {
    return { id: this.$route.params.id }
  },
  onSuccess: navigateToManagePage
})

function navigateToManagePage () {
  this.$router.push({ name: 'manage-games' })
}
